Apt.fn.extend('maps', {
	/**
	 * Bind event listener
	 *
	 * @param {String} layer
	 * @param {String} event
	 * @param {Function} fn
	 * @param {Boolean} [once=false]
	 */
	bind(layer, event, fn, once) {
		const scope = this;
		const instance = scope.$private.instance;
		const action = once ?
			'once' : 'on';

		if (! instance) {
			return;
		}

		instance.events[layer] = instance.events[layer] || [];
		instance.events[layer][event] = instance.events[layer][event] || [];

		instance.events[layer][event].push(fn);

		layer === 'map' ?
			scope.map[action](event, fn) :
			scope.map[action](event, layer, fn);
	},

	/**
	 * Remove event listener
	 *
	 * @param {String} layer
	 * @param {String} [event]
	 * @param {Function} [fn]
	 */
	unbind(layer, event, fn) {
		const scope = this;
		const instance = scope.$private.instance;

		let events = instance.events;

		events = events[layer];

		if (! events || ! events[event]) {
			return;
		}

		layer === 'map' ?
			scope.map.off(event, fn) :
			scope.map.off(event, layer, fn);

		instance.events[layer][event] = events[event].filter(e => e !== fn);
	},

	/**
	 * Debounce event
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @param {Boolean} [once=false]
	 * @returns {String}
	 */
	debounce(event, fn, once) {
		const scope = this;
		const priv = scope.$private;
		const uid = LS.util.uid();
		const timer = event + 'ed' + uid;
		const status = event + 'ing' + uid;
		const start = () => {
			clearTimeout(priv[timer]);

			priv[status] = true;
		};
		const end = e => {
			priv[timer] = setTimeout(() => {
				if (! scope.map || ! priv[status]) {
					return;
				}

				delete priv[status];

				try {
					fn(e);
				} catch (e) {
					//
				}

				if (once) {
					scope.unbounce(uid);
				}
			}, 100);
		};

		scope.map.on(event + 'start', start);
		scope.map.on(event + 'end', end);

		priv.instance.bounced[uid] = [
			event, start, end
		];

		return uid;
	},

	/**
	 * Remove debounce events
	 *
	 * @param {String} uid
	 */
	unbounce(uid) {
		const scope = this;
		const priv = scope.$private;
		const instance = priv.instance;

		const config = instance.bounced[uid];
		const event = config[0];

		clearTimeout(priv[event + 'ed' + uid]);

		scope.map.off(event + 'start', config[1]);
		scope.map.off(event + 'end', config[2]);

		delete instance.bounced[uid];
	}
});